export const ENTER = 'Enter';

export const SPACE = ' ';

export const TEST_ID = 'accordion';
